export const SET_AUTH_STATE = 'SET_AUTH_STATE'

interface SetAuthStateAction {
  type: typeof SET_AUTH_STATE
  authenticated: boolean
}

export type ActionTypes = SetAuthStateAction
